<template>
  <div class="">
    <el-dialog
      :title="type === 1 ? $t('components.Insert.9398966-0') : $t('components.Insert.9398966-1')"
      :visible.sync="show"
      :close-on-click-modal="false"
      :width="type === 3 ? '450px' : '1100px'"
      @open="handlerOpen"
      @closed="handlerClose"
    >
      <div class="wrap">
        <el-form ref="ruleForm" :rules="rules" :model="info" label-position="top" :hide-required-asterisk="true">
          <el-row :gutter="20">
            <el-col :span="24">
              <div style="color: red; margin-bottom: 4px">{{ $t('components.Insert.9398966-2') }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="name" :label="$t('components.Insert.9398966-3')">
                <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-card shadow="never" style="margin-bottom: 20px">
            <el-row>
              <div style="color: #333; font-size: 14px; text-decoration: underline; margin-bottom: 20px">
                {{ $t('components.Insert.9398966-5') }}
              </div>
            </el-row>
            <el-row :gutter="20">
              <div style="margin-left: 10px; font-style: italic; color: #333">{{ $t('components.Insert.9398966-6') }}</div>
              <el-col :span="8">
                <el-form-item prop="style.top.text" :label="$t('components.Insert.9398966-7')">
                  <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.style.top.text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="style.top.textSize" :label="$t('components.Insert.9398966-8')">
                  <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.style.top.textSize"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="display: flex">
                <el-form-item prop="style.top.textColor" :label="$t('components.Insert.9398966-9')" style="margin-right: 20px">
                  <el-color-picker v-model="info.style.top.textColor"></el-color-picker>
                </el-form-item>
                <el-form-item prop="style.top.bkColor" :label="$t('components.Insert.9398966-10')">
                  <el-color-picker v-model="info.style.top.bkColor"></el-color-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="!info.style.top.bkColor">
              <el-col :span="8">
                <el-form-item prop="style.top.img" :label="$t('components.Insert.9398966-11')">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.style.top.img"
                  />
                  <div style="color: #999; font-size: 12px">{{ $t('components.Insert.9398966-12') }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <div style="margin-left: 10px; font-style: italic; color: #333">{{ $t('components.Insert.9398966-13') }}</div>
              <el-col :span="8">
                <el-form-item :label="$t('components.Insert.9398966-7')" prop="style.popup.text">
                  <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.style.popup.text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('components.Insert.9398966-8')" prop="style.popup.textSize">
                  <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.style.popup.textSize"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="display: flex">
                <el-form-item prop="style.popup.textColor" :label="$t('components.Insert.9398966-9')" style="margin-right: 20px">
                  <el-color-picker v-model="info.style.popup.textColor"></el-color-picker>
                </el-form-item>
                <el-form-item :label="$t('components.Insert.9398966-10')" prop="style.popup.bkColor">
                  <el-color-picker v-model="info.style.popup.bkColor"></el-color-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item :label="$t('components.Insert.9398966-14')" prop="style.popup.posterImg">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.style.popup.posterImg"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('components.Insert.9398966-15')" prop="style.popup.confirmImg">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.style.popup.confirmImg"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('components.Insert.9398966-16')" prop="style.popup.cancelImg">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.style.popup.cancelImg"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 20px">
            <el-row>
              <div style="color: #333; font-size: 14px; text-decoration: underline; margin-bottom: 20px">
                {{ $t('components.Insert.9398966-17') }}
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8" style="display: flex; align-items: center; margin-bottom: 20px">
                <div style="margin-right: 20px">{{ $t('components.Insert.9398966-18') }}</div>
                <el-switch v-model="info.rule.isSwitch" :active-value="1" :inactive-value="0"> </el-switch>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('components.Insert.9398966-19')" prop="rule.conditionType">
                  <el-select v-model="info.rule.conditionType" :placeholder="$t('components.Insert.9398966-20')">
                    <el-option
                      v-for="item in conditionTypeArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.conditionType == 2">
                <el-form-item prop="rule.conditionValue" :label="$t('components.Insert.9398966-21')">
                  <el-input v-model="info.rule.conditionValue" :placeholder="$t('components.Insert.9398966-22')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.conditionType == 3">
                <el-form-item prop="rule.conditionValue" :label="$t('components.Insert.9398966-23')">
                  <el-input v-model="info.rule.conditionValue" :placeholder="$t('components.Insert.9398966-24')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.conditionType == 4">
                <el-form-item prop="rule.conditionValue" :label="$t('components.Insert.9398966-25')">
                  <el-input v-model="info.rule.conditionValue" :placeholder="$t('components.Insert.9398966-26')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.conditionType == 4">
                <el-form-item prop="rule.buyNum" :label="$t('components.Insert.9398966-27')">
                  <el-input v-model="info.rule.buyNum" :placeholder="$t('components.Insert.9398966-24')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('components.Insert.9398966-28')" prop="rule.contentType">
                  <el-select
                    v-model="info.rule.contentType"
                    @change="info.rule.contentValue = ''"
                    :placeholder="$t('components.Insert.9398966-20')"
                  >
                    <el-option v-for="item in contentTypeArr" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.contentType == 1">
                <el-form-item prop="rule.contentValue" :label="$t('components.Insert.9398966-29')">
                  <el-input v-model="info.rule.contentValue" :placeholder="$t('components.Insert.9398966-22')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.contentType == 2">
                <el-form-item prop="rule.contentValue" :label="$t('components.Insert.9398966-30')">
                  <el-input v-model="info.rule.contentValue" :placeholder="$t('components.Insert.9398966-31')">
                    <template v-if="info.rule.contentType == 2" #append> % </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.contentType == 3">
                <el-form-item prop="rule.contentValue" :label="$t('components.Insert.9398966-32')">
                  <el-input v-model="info.rule.contentValue" :placeholder="$t('components.Insert.9398966-33')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="info.rule.contentType == 3">
                <el-form-item prop="rule.contentNum" :label="$t('components.Insert.9398966-34')">
                  <el-input v-model="info.rule.contentNum" :placeholder="$t('components.Insert.9398966-35')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>

          <el-card shadow="never" style="margin-bottom: 20px">
            <el-row>
              <div style="color: #333; font-size: 14px; text-decoration: underline; margin-bottom: 20px">
                {{ $t('components.Insert.9398966-36') }}
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8" style="display: flex; align-items: center; margin-bottom: 20px">
                <div style="margin-right: 20px">{{ $t('components.Insert.9398966-37') }}</div>
                <el-switch v-model="info.recommend.coupon.isSwitch" :active-value="1" :inactive-value="0"> </el-switch>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="info.recommend.coupon.isSwitch == 1" style="margin-bottom: 20px">
              <el-col :span="6">
                <el-form-item prop="recommend.coupon.id">
                  <el-select
                    :multiple-limit="10"
                    v-model.trim="info.recommend.coupon.id"
                    v-el-select-loadmore="handleLoadmore"
                    filterable
                    remote
                    @change="changeCoupon"
                    :remote-method="handleAttrValueFilter"
                    :placeholder="$t('components.Insert.9398966-38')"
                  >
                    <el-option v-for="item in couponArr" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <div style="line-height: 40px">{{ $t('components.Insert.9398966-39') }}{{ info.recommend.coupon.num }}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="info.recommend.coupon.isSwitch == 1">
              <el-col :span="8" style="display: flex; align-items: center; margin-bottom: 20px">
                <el-form-item prop="recommend.coupon.pushBtn" :label="$t('components.Insert.9398966-40')">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.recommend.coupon.pushBtn"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8" style="display: flex; align-items: center; margin-bottom: 20px">
                <el-form-item prop="recommend.coupon.pushBkImg" :label="$t('components.Insert.9398966-41')">
                  <CustomUploadImg
                    :action="action"
                    :accept="'.png,.jpg'"
                    :headers="headers"
                    :url.sync="info.recommend.coupon.pushBkImg"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 20px">
            <el-row>
              <div style="color: #333; font-size: 14px; text-decoration: underline; margin-bottom: 20px">
                {{ $t('components.Insert.9398966-42') }}
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col
                :span="8"
                style="display: flex; align-items: center; margin: 0 0 10px"
                :style="{
                  marginBottom: info.recommend.popupProduct.isSwitch == 0 ? '20px' : '0px'
                }"
              >
                <div style="margin-right: 20px">{{ $t('components.Insert.9398966-43') }}</div>
                <el-switch v-model="info.recommend.popupProduct.isSwitch" :active-value="1" :inactive-value="0">
                </el-switch>
              </el-col>
            </el-row>
            <template v-if="info.recommend.popupProduct.isSwitch == 1">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-44')" prop="recommend.popupProduct.title">
                    <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.recommend.popupProduct.title"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-8')" prop="recommend.popupProduct.titleSize">
                    <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.recommend.popupProduct.titleSize"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-9')" prop="recommend.popupProduct.titleColor">
                    <el-color-picker v-model="info.recommend.popupProduct.titleColor"></el-color-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-45')" prop="recommend.popupProduct.content">
                    <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.recommend.popupProduct.content"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-8')" prop="recommend.popupProduct.contentSize">
                    <el-input :placeholder="$t('components.Insert.9398966-4')" v-model="info.recommend.popupProduct.contentSize"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-9')" prop="recommend.popupProduct.contentColor">
                    <el-color-picker v-model="info.recommend.popupProduct.contentColor"></el-color-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" style="display: flex">
                  <el-form-item :label="$t('components.Insert.9398966-10')" prop="recommend.popupProduct.bkColor" style="margin-right: 20px">
                    <el-color-picker v-model="info.recommend.popupProduct.bkColor"></el-color-picker>
                  </el-form-item>
                  <el-form-item :label="$t('components.Insert.9398966-46')" prop="recommend.popupProduct.productBkColor">
                    <el-color-picker v-model="info.recommend.popupProduct.productBkColor"></el-color-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="4">
                  <el-form-item :label="$t('components.Insert.9398966-47')" prop="recommend.popupProduct.exitBtn">
                    <CustomUploadImg
                      :action="action"
                      :accept="'.png,.jpg'"
                      :headers="headers"
                      :url.sync="info.recommend.popupProduct.exitBtn"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item :label="$t('components.Insert.9398966-48')" prop="recommend.popupProduct.cartBtn">
                    <CustomUploadImg
                      :action="action"
                      :accept="'.png,.jpg'"
                      :headers="headers"
                      :url.sync="info.recommend.popupProduct.cartBtn"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item :label="$t('components.Insert.9398966-49')" prop="recommend.popupProduct.payBtn">
                    <CustomUploadImg
                      :action="action"
                      :accept="'.png,.jpg'"
                      :headers="headers"
                      :url.sync="info.recommend.popupProduct.payBtn"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-50')" prop="recommend.popupProduct.line">
                    <el-input
                      v-for="(item, index) in info.recommend.popupProduct.line"
                      :key="index"
                      style="margin-bottom: 10px"
                      :placeholder="$t('components.Insert.9398966-33')"
                      v-model="item.lineNum"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-51')" prop="recommend.popupProduct.line.discount">
                    <el-input
                      v-for="(item, index) in info.recommend.popupProduct.line"
                      :key="index"
                      style="margin-bottom: 10px"
                      :placeholder="$t('components.Insert.9398966-4')"
                      v-model="item.discount"
                    >
                      <template slot="append">%</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row :gutter="20">
              <el-col
                :span="8"
                style="display: flex; align-items: center; margin: 0 0 10px"
                :style="{
                  marginBottom: info.recommend.bottomProduct.isSwitch == 0 ? '20px' : '0px'
                }"
              >
                <div style="margin-right: 20px">{{ $t('components.Insert.9398966-52') }}</div>
                <el-switch v-model="info.recommend.bottomProduct.isSwitch" :active-value="1" :inactive-value="0">
                </el-switch>
              </el-col>
            </el-row>
            <template v-if="info.recommend.bottomProduct.isSwitch == 1">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-53')">
                    <el-input-number
                      :min="1"
                      :step="1"
                      v-model="recommendNum"
                      @change="changeRecommendNum"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="recommendNum > 0">
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-50')">
                    <el-input
                      v-for="(item, index) in info.recommend.bottomProduct.line"
                      :key="index"
                      style="margin-bottom: 10px"
                      :placeholder="$t('components.Insert.9398966-33')"
                      v-model="item.lineNum"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('components.Insert.9398966-51')">
                    <el-input
                      v-for="(item, index) in info.recommend.bottomProduct.line"
                      :key="index"
                      style="margin-bottom: 10px"
                      :placeholder="$t('components.Insert.9398966-31')"
                      v-model="item.discount"
                    >
                      <template #append>%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-card>
          <el-card shadow="never">
            <el-row>
              <div style="color: #333; font-size: 14px; text-decoration: underline; margin-bottom: 20px">
                {{ $t('components.Insert.9398966-54') }}
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('components.Insert.9398966-55')" prop="activePeriod.startDate">
                  <el-date-picker
                    v-model="recommendDate"
                    @change="changeDate"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('components.Insert.9398966-56')"
                    :start-placeholder="$t('components.Insert.9398966-57')"
                    :end-placeholder="$t('components.Insert.9398966-58')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('components.Insert.9398966-59')" prop="activePeriod.time">
                  <CustomDayTimePicker v-model="info.activePeriod.time" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlerClose">{{ $t('components.Insert.9398966-60') }}</el-button>
        <el-button :loading="submitLoading" v-if="type !== 3" type="primary" @click="handlerSubmit">{{ $t('components.Insert.9398966-61') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  import CustomUploadImg from "@/components/CustomUploadImg.vue";
  import CustomDayTimePicker from "@/components/CustomDayTimePicker.vue";
  export default {
    components: { CustomUploadImg, CustomDayTimePicker },
    directives: {
      "el-select-loadmore": {
        //自定义指令
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop - 15 <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    props: {
      show: {
        default: false,
        type: Boolean
      },
      type: {
        default: 1, //1 insert 2 edit 3 preview
        type: Number
      },
      rowData: {
        default: () => {},
        type: Object
      },
      hasInfo: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        submitLoading: false,
        //数据结构与默认值
        info: {
          name: "",
          type: "",
          style: {
            top: {
              text: "",
              textSize: "",
              textColor: "#000000",
              bkColor: "#FFFFFF",
              img: ""
            },
            popup: {
              text: "",
              textSize: "",
              textColor: "#000000",
              bkColor: "#FFFFFF",
              posterImg: "",
              confirmImg: "",
              cancelImg: ""
            }
          },
          rule: {
            isSwitch: 0,
            conditionType: 1,
            conditionValue: "",
            buyNum: "",
            contentType: 1,
            contentValue: ""
          },
          recommend: {
            coupon: {
              isSwitch: "",
              id: "",
              num: 0,
              pushBtn: "",
              pushBkImg: ""
            },
            popupProduct: {
              isSwitch: 0,
              title: "",
              titleSize: "",
              titleColor: "#FFFFFF",
              content: "",
              contentSize: "",
              contentColor: "#FFFFFF",
              bkColor: "#FFFFFF",
              productBkColor: "#FFFFFF",
              exitBtn: "",
              cartBtn: "",
              line: [
                {
                  lineNum: "",
                  discount: ""
                },
                {
                  lineNum: "",
                  discount: ""
                },
                {
                  lineNum: "",
                  discount: ""
                }
              ]
            },
            bottomProduct: {
              isSwitch: 0,
              line: [
                {
                  lineNum: "",
                  discount: ""
                }
              ]
            }
          },
          activePeriod: {
            startDate: "",
            endDate: "",
            time: []
          }
        },
        //表单规则
        rules: {
          name: [{ required: true, message: this.$t('components.Insert.9398966-62') }],
          type: [{ required: true, message: this.$t('components.Insert.9398966-63') }],
          "style.top.text": [{ required: true, message: this.$t('components.Insert.9398966-64') }],
          "style.top.textSize": [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('components.Insert.9398966-65')));
                } else if (!/^\d+$/.test(value)) {
                  callback(new Error(this.$t('components.Insert.9398966-66')));
                } else {
                  callback();
                }
              }
            }
          ],
          "style.top.textColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "style.top.img": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "style.popup.text": [{ required: true, message: this.$t('components.Insert.9398966-64') }],
          "style.popup.textSize": [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('components.Insert.9398966-65')));
                } else if (!/^\d+$/.test(value)) {
                  callback(new Error(this.$t('components.Insert.9398966-66')));
                } else {
                  callback();
                }
              }
            }
          ],
          "style.popup.textColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "style.popup.bkColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "style.popup.posterImg": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "style.popup.confirmImg": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "style.popup.cancelImg": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "rule.conditionType": [{ required: true, message: this.$t('components.Insert.9398966-69') }],
          "rule.conditionValue": [{ required: true, message: this.$t('components.Insert.9398966-22') }],
          "rule.buyNum": [{ required: true, message: this.$t('components.Insert.9398966-70') }],
          "rule.contentType": [{ required: true, message: this.$t('components.Insert.9398966-71') }],
          "rule.contentValue": [{ required: true, message: this.$t('components.Insert.9398966-4') }],
          "rule.contentNum": [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('components.Insert.9398966-70')));
                } else if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error(this.$t('components.Insert.9398966-66')));
                } else {
                  callback();
                }
              }
            }
          ],
          "recommend.coupon.id": [{ required: true, message: this.$t('components.Insert.9398966-38') }],
          "recommend.popupProduct.title": [{ required: true, message: this.$t('components.Insert.9398966-72') }],
          "recommend.popupProduct.titleSize": [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('components.Insert.9398966-65')));
                } else if (!/^\d+$/.test(value)) {
                  callback(new Error(this.$t('components.Insert.9398966-66')));
                } else {
                  callback();
                }
              }
            }
          ],
          "recommend.popupProduct.titleColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "recommend.popupProduct.content": [{ required: true, message: this.$t('components.Insert.9398966-4') }],
          "recommend.popupProduct.contentSize": [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('components.Insert.9398966-65')));
                } else if (!/^\d+$/.test(value)) {
                  callback(new Error(this.$t('components.Insert.9398966-66')));
                } else {
                  callback();
                }
              }
            }
          ],
          "recommend.popupProduct.contentColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "recommend.popupProduct.bkColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "recommend.popupProduct.productBkColor": [{ required: true, message: this.$t('components.Insert.9398966-67') }],
          "recommend.popupProduct.exitBtn": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "recommend.popupProduct.cartBtn": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "recommend.popupProduct.payBtn": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "activePeriod.startDate": [{ required: true, message: this.$t('components.Insert.9398966-73') }],
          "recommend.coupon.pushBtn": [{ required: true, message: this.$t('components.Insert.9398966-68') }],
          "recommend.coupon.pushBkImg": [{ required: true, message: this.$t('components.Insert.9398966-68') }]
        },
        conditionTypeArr: [
          {
            value: 1,
            label: this.$t('components.Insert.9398966-74')
          },
          {
            value: 2,
            label: this.$t('components.Insert.9398966-75')
          },
          {
            value: 3,
            label: this.$t('components.Insert.9398966-76')
          },
          {
            value: 4,
            label: this.$t('components.Insert.9398966-77')
          }
        ],
        contentTypeArr: [
          {
            value: 1,
            label: this.$t('components.Insert.9398966-78')
          },
          {
            value: 2,
            label: this.$t('components.Insert.9398966-79')
          },
          {
            value: 3,
            label: this.$t('components.Insert.9398966-80')
          }
        ],
        headers: {
          token: this.$cookies.get("token")
        },
        action: config.baseUrl + this.$url.SalesPlan.upload,
        recommendDate: null,
        //商品推荐数量
        recommendNum: 0,
        selectLoading: false,
        lock: true,
        selectObj: {
          pageNum: 1,
          pageSize: 10,
          name: ""
        },
        couponArr: [],
        //   type2 的时候的促销前置条件设置
        conditionTypeArr2: [
          {
            value: 5,
            label: this.$t('components.Insert.9398966-81')
          }
        ],
        //type2的时候促销时机数组
        conditionValueArr2: [
          {
            value: "1",
            label: this.$t('components.Insert.9398966-82')
          },
          {
            value: "2",
            label: this.$t('components.Insert.9398966-83')
          }
        ],
        contentTypeArr2: [
          {
            value: 3,
            label: this.$t('components.Insert.9398966-84')
          },
          {
            value: 4,
            label: this.$t('components.Insert.9398966-85')
          }
        ]
      };
    },
    computed: {},
    watch: {},
    methods: {
      // 切换促销活动类型
      handlerChangeType(type) {
        let id = this.info.id;
        let name = this.info.name;
        this.handlerRest();
        this.info.id = id;
        this.info.name = name;
        if (type == 2) {
          this.info.rule.conditionType = 5;
          this.info.rule.contentType = 3;
        }
      },
      //优惠券下拉
      changeCoupon(e) {
        let overCount = this.couponArr.find(item => item.id === e).overCount;
        this.info.recommend.coupon.num = overCount;
      },
      handleLoadmore() {
        //下拉加载
        if (!this.selectLoading) {
          this.handlerGetSelect();
        }
      },
      handleAttrValueFilter(name) {
        this.couponArr = [];
        if (!this.selectLoading) {
          this.selectObj.name = name;
          this.selectObj.pageNum = 1;
          this.handlerGetSelect();
        }
      },
      handlerGetSelect() {
        let that = this;
        if (this.lock) {
          //节流
          that.lock = false;
          let timer = setTimeout(() => {
            clearTimeout(timer);
            that.lock = true;
          }, 300);
        } else {
          return;
        }
        let url = this.$url.Product.getCoupons;
        let method = this.$method.get;
        let params = {
          currentPage: this.selectObj.pageNum,
          name: this.selectObj.name,
          username: this.username
        };
        this.$api.request(url, method, params).then(res => {
          if (res.code === 0) {
            if (res.data.records.length > 0) {
              this.selectObj.pageNum++;
            }
            if (res.data.current == 1) {
              this.couponArr = res.data.records;
            } else {
              this.couponArr = this.couponArr.concat(res.data.records);
            }
          }
        });
      },
      //修改商品推荐数量
      changeRecommendNum(e) {
        if (parseInt(e) != e) {
          this.$message.warning(this.$t('components.Insert.9398966-66'));
          return;
        }
        if (this.info.recommend.bottomProduct.line.length < e) {
          for (let i = this.info.recommend.bottomProduct.line.length; i < e; i++) {
            this.info.recommend.bottomProduct.line.push({
              lineNum: "",
              discount: ""
            });
          }
        } else {
          for (let i = this.info.recommend.bottomProduct.line.length; i > e; i--) {
            this.info.recommend.bottomProduct.line.pop();
          }
        }
      },
      changeDate(e) {
        if (e) {
          this.info.activePeriod.startDate = e[0];
          this.info.activePeriod.endDate = e[1];
        } else {
          this.info.activePeriod.startDate = "";
          this.info.activePeriod.endDate = "";
        }
      },
      createAllTime() {
        const timeSlots = [];
        const daysInWeek = 7;
        const hoursInDay = 24;

        for (let day = 1; day <= daysInWeek; day++) {
          for (let hour = 0; hour < hoursInDay; hour++) {
            const beginTime = `${String(hour).padStart(2, "0")}:00`;
            const endTime = `${String(hour).padStart(2, "0")}:59`;

            timeSlots.push({
              beginTime: beginTime,
              endTime: endTime,
              week: day
            });
          }
        }
        return timeSlots;
      },
      //   还原数据
      handlerRest() {
        this.recommendDate = null;
        this.info = {
          name: "",
          type: "",
          style: {
            top: {
              text: "",
              textSize: "",
              textColor: "#000000",
              bkColor: "#FFFFFF",
              img: ""
            },
            popup: {
              text: "",
              textSize: "",
              textColor: "#000000",
              bkColor: "#FFFFFF",
              posterImg: "",
              confirmImg: "",
              cancelImg: ""
            }
          },
          rule: {
            isSwitch: 0,
            conditionType: 1,
            conditionValue: "",
            buyNum: "",
            contentType: 1,
            contentValue: ""
          },
          recommend: {
            coupon: {
              isSwitch: "",
              id: "",
              num: 0,
              pushBtn: "",
              pushBkImg: ""
            },
            popupProduct: {
              isSwitch: 0,
              title: "",
              titleSize: "",
              titleColor: "#FFFFFF",
              content: "",
              contentSize: "",
              contentColor: "#FFFFFF",
              bkColor: "#FFFFFF",
              productBkColor: "#FFFFFF",
              exitBtn: "",
              cartBtn: "",
              line: [
                {
                  lineNum: "",
                  discount: ""
                },
                {
                  lineNum: "",
                  discount: ""
                },
                {
                  lineNum: "",
                  discount: ""
                }
              ]
            },
            bottomProduct: {
              isSwitch: 0,
              line: [
                {
                  lineNum: "",
                  discount: ""
                }
              ]
            }
          },
          activePeriod: {
            startDate: "",
            endDate: "",
            time: []
          }
        };
      },
      handlerOpen() {
        //init couponArr
        this.handlerGetSelect();
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        // type 1
        this.handlerRest();
        //type2 3  编辑回显数据
        if (this.type !== 1) {
          let info = JSON.parse(JSON.stringify(this.rowData));
          if (info.activePeriod.time.length <= 0) {
            info.activePeriod.time = this.createAllTime();
          }
          let recommendDate = [];
          recommendDate.push(info.activePeriod.startDate);
          recommendDate.push(info.activePeriod.endDate);

          this.info = info;
          this.recommendDate = recommendDate;
        }
      },
      handlerClose() {
        this.$emit("close");
      },
      // 提交
      handlerSubmit() {
        //复制数据防止污染
        this.$refs.ruleForm.validate((valid, fields) => {
          if (valid) {
            let info = JSON.parse(JSON.stringify(this.info));
            console.log(info, this.$t('components.Insert.9398966-86'));
            //复杂判断
            if (info.recommend.popupProduct.isSwitch == 1) {
              for (let i = 0; i < info.recommend.popupProduct.line.length; i++) {
                if (!/^(?:[1-9][0-9]{0,2}|1000)$/.test(info.recommend.popupProduct.line[i].lineNum)) {
                  this.$message.warning(this.$t('components.Insert.9398966-87'));
                  return;
                }
                if (!/^(?:[1-9][0-9]?|100)$/.test(info.recommend.popupProduct.line[i].discount)) {
                  this.$message.warning(this.$t('components.Insert.9398966-88'));
                  return;
                }
              }
            }
            if (info.recommend.bottomProduct.isSwitch == 1) {
              for (let i = 0; i < info.recommend.bottomProduct.line.length; i++) {
                if (!/^(?:[1-9][0-9]{0,2}|1000)$/.test(info.recommend.bottomProduct.line[i].lineNum)) {
                  this.$message.warning(this.$t('components.Insert.9398966-89'));
                  return;
                }
                if (!/^(?:[1-9][0-9]?|100)$/.test(info.recommend.bottomProduct.line[i].discount)) {
                  this.$message.warning(this.$t('components.Insert.9398966-90'));
                  return;
                }
              }
            }
            if (info.activePeriod.time.length <= 0) {
              this.$message.warning(this.$t('components.Insert.9398966-91'));
              return;
            }
            if (info.activePeriod.time.length >= 168) {
              info.activePeriod.time = [];
            }
            // 颜色和背景只能存在一个判断
            if (info.style.top.bkColor) {
              delete info.style.top.img;
            } else {
              delete info.style.top.bkColor;
            }
            // 发请求
            this.submitLoading = true;
            if (this.type === 1) {
              //添加
              this.$api
                .request(this.$url.SalesPlan.insert, this.$method.post, info)
                .then(res => {
                  if (res.code == 0) {
                    this.$message.success(this.$t('components.Insert.9398966-92'));
                    this.$emit("refresh");
                  } else {
                    this.$message.warning(res.msg);
                  }
                })
                .catch(err => {
                  this.$message.warning(err.msg);
                })
                .finally(() => {
                  this.submitLoading = false;
                });
            } else if (this.type === 2) {
              //编辑
              this.$api
                .request(this.$url.SalesPlan.update, this.$method.put, info)
                .then(res => {
                  if (res.code == 0) {
                    this.$message.success(this.$t('components.Insert.9398966-92'));
                    this.$emit("refresh");
                  } else {
                    this.$message.warning(res.msg);
                  }
                })
                .catch(err => {
                  this.$message.warning(err.msg);
                })
                .finally(() => {
                  this.submitLoading = false;
                });
            }
          } else {
            console.log("error submit!!", fields);
            let key = Object.keys(fields)[0];
            let msg = (fields[key] || [{}])[0].message;
            this.$message.warning(msg || this.$t('components.Insert.9398966-93'));
            return false;
          }
        });
      }
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {}
  };
</script>

<style lang="scss" scoped>
  .wrap {
    user-select: none;
    width: 100%;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
    height: auto;
  }
  .btn {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    .btn_wrap {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon {
        font-size: 20px;
      }
      .btn_title {
        text-align: center;
        margin-top: 6px;
        line-height: 1;
      }
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    object-fit: contain;
  }
  .single-dashed-line {
    border-bottom: 1px dashed #000;
    width: 100%;
    margin: 10px 0;
  }
  .double-dashed-line {
    border-bottom: 1px dashed #000;
    border-top: 1px dashed #000;
    width: 100%;
    height: 1px;
    margin: 10px 0;
  }
  .divider {
    border-top: 1px solid #000;
    width: 100%;
    margin: 10px 0;
  }
  .big-divider {
    border-bottom: 1px solid #000;
    border-top: 3px solid #000;
    width: 100%;
    height: 2px;
    margin: 10px 0;
  }
  .spmx {
    gap: 20px;
    display: flex;
    justify-content: space-between;
    .right {
      text-align: right;
    }
  }
  .sfmx {
    text-align: right;
    .input_line {
      display: flex;
      justify-content: right;
    }
  }
  .fplx {
    ::v-deep .center_input input {
      text-align: center;
    }
    ::v-deep .center_input input::placeholder {
      text-align: center;
    }
  }
  .abn {
    display: flex;
    justify-content: center;
  }
  .fphm {
    display: flex;
    justify-content: center;
  }
  .dbbh {
    display: flex;
    justify-content: center;
  }
  .choose_card {
    ::v-deep .el-card__body {
      padding: 0;
    }
  }
  .shoubing {
    border: 1px dotted #d9d9d9;
    padding: 10px;
    margin: 10px 0;
    cursor: pointer;
  }
  .setting {
    margin: 5px 0;
    display: flex;
    justify-content: flex-end;
    span {
      display: inline-block;
      width: 33.33%;
      text-align: center;
    }
  }
</style>
